import React from 'react';

const industries = [
  'Automobilzulieferer',
  'Maschinenbau',
  'Lebensmittelindustrie',
  'Pharma',
  'Chemie',
  'Metallverarbeitung',
  'Verpackung',
  'Halbleiter',
];

export default function Industries() {
  return (
    <section className="py-16 border-y border-slate-200/70 overflow-hidden" data-testid="industries-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 mb-8">
        <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-slate-500 text-center">
          Vertraut von Industrieunternehmen in DACH
        </div>
      </div>
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#f6f7f9] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#f6f7f9] to-transparent z-10 pointer-events-none" />
        <div className="flex marquee whitespace-nowrap gap-16">
          {[...industries, ...industries].map((name, i) => (
            <div key={`${name}-${i < industries.length ? 'a' : 'b'}`} className="font-display font-bold text-xl sm:text-2xl md:text-3xl text-slate-400 tracking-tight shrink-0">
              {name} <span className="text-[#0891b2] mx-4 sm:mx-6">/</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
